const UIModal = require('app/ui/Modal');
const GraphQLMutation = require('app/graphql/Mutation');

class Modal {

    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': window.translate('app.billing.payment.export.title'),
            'format': null,
            'filters': [],
            'onClose': function(event){},
            'onShown': function(event){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.format = this.settings.format;
        if(!this.format){
            console.error("Missing format parameter for PaimentExportModal");
            return;
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('billing-paiement-export-excel-modal');

        this.modal = new UIModal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "xl",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.buildContent();

        this.modal.show();
    }

    refresh(){
        this.buildContent();
    }

    buildContent(){
        this.$resultContainer = $('<div/>');
        this.$content
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center')
            .append(this.$resultContainer)
        )

        this.generateFile();
    }

    getParametersAsString(){
        return JSON.stringify(this.settings.parameters);
    }

    generateFile(){
        var self = this;

        this.$resultContainer
        .html('')
        .append(window.App.generateLoader())
        .show();

        let fields = [
            'success',
            'message',
            'file { url id }',
            'errors { key, value }',
        ];
        let variables = {
            'type':{
                'value': this.format,
                'type': "String!"
            },
            'queryParameters': {
                'value': this.getParametersAsString(),
                'type': "String"
            }
        };

        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "ExportBillingPayment",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    self.showResult(data);
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
            }
        });
        mutation.execute();

    }

    showResult(data){
        let url = window.App.get('apiBaseUrl')+data.file.url;

        let icon = 'fa-file-'+this.format;
        let $buttonShow = $('<a/>')
        .attr('download','download')
        .attr('href',url)
        .addClass('btn btn-success')
        .append(
            $('<i/>')
            .addClass("fas "+icon+" me-1")
        )
        .append(window.translate('downloadFile'));

        if(this.format == 'pdf'){
            $buttonShow.attr('target','_blank');
        }


        this.$resultContainer
        .html('')
        .append($buttonShow)
        .show();
    }
}

module.exports = Modal;

